export default {
  "cgu": {
    "heroTitle": "使用条款和条件",
    "lastUpdated": "最后更新：2026年8月3日",
    "sections": [
      {
        "title": "1. 序言",
        "paragraphs": [
          "本使用条款和条件（以下简称「使用条款」）规范访问和使用 is-telecom.co 网站（以下简称「本网站」），该网站由 IS TELECOM 发布，IS TELECOM 是一家在贝宁注册的公司，注册地址位于贝宁科托努。",
          "通过访问本网站并浏览其页面，用户（以下简称「用户」）完全无保留地接受本使用条款。如果用户不接受这些条件，请勿使用本网站。"
        ]
      },
      {
        "title": "2. 网站目的",
        "paragraphs": ["本网站旨在展示 IS TELECOM 在以下领域提供的活动、服务和产品："],
        "list": [
          "光伏微电网和农村电气化",
          "太阳能抽水和灌溉解决方案",
          "储能和锂电池",
          "电动汽车充电",
          "金属结构和土木工程",
          "信息技术、网络和监控系统",
          "能源审计和咨询",
          "电信和基础设施",
          "运输和物流"
        ],
        "paragraphsAfter": [
          "本网站还允许用户请求报价、联系 IS TELECOM 以及查看公司已完成项目的信息。"
        ]
      },
      {
        "title": "3. 网站访问",
        "paragraphs": [
          "本网站对所有有互联网连接的用户免费开放。IS TELECOM 采取必要措施确保网站每天24小时、每周7天可用，但因不可抗力、技术维护或需要临时中断的更新除外。",
          "IS TELECOM 保留修改、暂停或中断全部或部分网站访问的权利，恕不另行通知，且不产生任何赔偿。"
        ]
      },
      {
        "title": "4. 知识产权",
        "paragraphs": [
          "构成本网站的所有元素（文本、图形、标志、图标、图像、视频、声音、软件、数据库等）是 IS TELECOM 或其合作伙伴的专有财产，并受知识产权法保护。",
          "未经 IS TELECOM 事先书面授权，以任何方式对本网站元素进行全部或部分复制、展示、修改、发布、改编或利用，均被严格禁止，并构成侵权。"
        ]
      },
      {
        "title": "5. 网站使用",
        "paragraphs": ["用户承诺公平且按照网站目的使用本网站。用户特别禁止以下行为："],
        "list": [
          "为非法或欺诈目的使用本网站",
          "引入病毒、特洛伊木马、蠕虫或任何其他恶意软件",
          "中断或干扰对本网站或其服务器的访问",
          "未经同意收集其他用户的个人数据",
          "传播诽谤、侮辱、淫秽或危害公共秩序的内容"
        ]
      },
      {
        "title": "6. 超链接",
        "paragraphs": [
          "本网站可能包含指向第三方网站的链接。IS TELECOM 不对这些网站的内容进行任何控制，也不对其内容、准确性或运营承担任何责任。激活这些链接由用户自行负责。",
          "创建指向本网站的超链接必须事先获得 IS TELECOM 的书面授权。IS TELECOM 保留要求删除任何未经授权链接的权利。"
        ]
      },
      {
        "title": "7. 责任",
        "paragraphs": [
          "IS TELECOM 努力确保本网站发布信息的准确性和及时更新。然而，IS TELECOM 无法保证所提供信息的完整性、准确性或无错误。建议用户在做出任何决定之前向 IS TELECOM 核实信息的准确性。",
          "对于因使用本网站、无法访问本网站或查看链接网站内容而导致的直接或间接损害，IS TELECOM 不承担责任。"
        ]
      },
      {
        "title": "8. 个人数据",
        "paragraphs": [
          "IS TELECOM 根据其隐私政策收集和处理用户个人数据，该政策可在本网站上查阅。建议用户查阅该政策以了解其数据如何被收集、使用和保护。"
        ]
      },
      {
        "title": "9. Cookies",
        "paragraphs": [
          "本网站使用 cookies 和类似技术来改善浏览体验、分析流量和个性化内容。用户可以通过浏览器设置管理其 cookie 偏好。"
        ]
      },
      {
        "title": "10. 使用条款的修改",
        "paragraphs": [
          "IS TELECOM 保留随时修改本使用条款的权利，特别是为了适应法律、法规或技术发展。修改自在本网站上发布之日起生效。建议用户定期查阅使用条款以了解可能的修改。"
        ]
      },
      {
        "title": "11. 适用法律和管辖法院",
        "paragraphs": [
          "本使用条款受贝宁法律管辖。如因本使用条款的解释、执行或有效性产生争议，双方承诺在采取任何法律行动前寻求友好解决方案。如无法达成友好协议，贝宁科托努有管辖权的法院将拥有专属管辖权。"
        ]
      },
      {
        "title": "12. 联系方式",
        "paragraphs": [
          "如有关于本使用条款或网站运营的任何问题，用户可通过以下联系方式联系 IS TELECOM："
        ]
      }
    ]
  }
};